import Cookies from 'js-cookie';
import { actionTypes } from './reducer';

const ANONYMIZED_COOKIE_KEY = 'anonymizeStudentData';

const getExpiry = () => {
  // create an expiry date for 02:00am tomorrow morning
  let expiry = new Date();
  expiry.setDate(expiry.getDate() + 1);
  expiry.setHours(2);
  expiry.setMinutes(0);
  expiry.setSeconds(0);
  expiry.setMilliseconds(0);
  return expiry;
};

const createAnonymizeProfilesCookie = () => {
  const expiry = getExpiry();
  Cookies.set(ANONYMIZED_COOKIE_KEY, true, { expires: expiry });
};
const removeAnonymizeProfilesCookie = () => {
  Cookies.remove(ANONYMIZED_COOKIE_KEY);
};

// returns a thunk
export const initializeAnonymizer = () => (dispatch, getState) => {
  if (Cookies.get(ANONYMIZED_COOKIE_KEY)) {
    dispatch(anonymizeProfiles());
  }
};

// returns a thunk
export const anonymizeProfiles = () => (dispatch) => {
  createAnonymizeProfilesCookie();
  dispatch({
    type: actionTypes.ANONYMIZE_PROFILES,
  });
};

// returns a thunk
export const deanonymizeProfiles = () => (dispatch) => {
  removeAnonymizeProfilesCookie();
  dispatch({
    type: actionTypes.DEANONYMIZE_PROFILES,
  });
};
